import React, { useContext } from "react";

import { Col, Row, Typography } from "antd";
import { AppContext } from "App";
import greenTickIcon from "assets/images/home/green_submission_tick.svg";
import StartButtonPricing from "components/basic/StartButtonPricing";
import PriceTables from "components/pages/Prices/components/PriceTables";

const SubmissionBanner = () => {
    const { isMobile } = useContext(AppContext);

    type FeatureKey =
        | "bestFor"
        | "submission"
        | "hmrc"
        | "calculation"
        | "vat"
        | "taxzap"
        | "fines"
        | "accountant";

    const plans = [
        {
            title: "Simple Return",
            price: "£49",
            subtitle: "Get Started",
            features: {
                bestFor: "Simple return for employment income only (PAYE)",
                submission: "Instant",
                hmrc: <img src={greenTickIcon} alt="checkmark"/>,
                calculation: <img src={greenTickIcon} alt="checkmark"/>,
                vat: <img src={greenTickIcon} alt="checkmark"/>,
                taxzap: <img src={greenTickIcon} alt="checkmark"/>,
                fines: <img src={greenTickIcon} alt="checkmark"/>,
            },
        },
        {
            title: "Self Employed Return",
            price: "£89",
            subtitle: "Get Started",
            features: {
                bestFor: "For self-employment businesses, CIS, or rental income (one source only)",
                submission: "Instant",
                hmrc: <img src={greenTickIcon} alt="checkmark"/>,
                calculation: <img src={greenTickIcon} alt="checkmark"/>,
                vat: <img src={greenTickIcon} alt="checkmark"/>,
                taxzap: <img src={greenTickIcon} alt="checkmark"/>,
                fines: <img src={greenTickIcon} alt="checkmark"/>,
            },
        },
        {
            title: "Standard Return",
            price: "£159",
            subtitle: "Get Started",
            features: {
                bestFor: "For multiple income sources",
                submission: "Instant",
                hmrc: <img src={greenTickIcon} alt="checkmark"/>,
                calculation: <img src={greenTickIcon} alt="checkmark"/>,
                vat: <img src={greenTickIcon} alt="checkmark"/>,
                taxzap: <img src={greenTickIcon} alt="checkmark"/>,
                fines: <img src={greenTickIcon} alt="checkmark"/>,
            },
        },
        {
            title: "Reviewed Return",
            price: "£220",
            subtitle: "Get Started",
            features: {
                bestFor: "Standard return plus an accredited accountant's review for added peace of mind",
                submission: "Reviewed and submitted by an accountant",
                hmrc: <img src={greenTickIcon} alt="checkmark"/>,
                calculation: <img src={greenTickIcon} alt="checkmark"/>,
                vat: <img src={greenTickIcon} alt="checkmark"/>,
                taxzap: <img src={greenTickIcon} alt="checkmark"/>,
                fines: <img src={greenTickIcon} alt="checkmark"/>,
                accountant: <img src={greenTickIcon} alt="checkmark"/>,
            },
        },
    ];
    const featureLabels: { key: FeatureKey; label: string }[] = [
        { key: "bestFor", label: "Best For" },
        { key: "submission", label: "Submission to HMRC" },
        { key: "hmrc", label: "HMRC-recognised tax return" },
        { key: "calculation", label: "Full calculation of your tax bill for you to review and approve" },
        { key: "vat", label: "VAT included in the price" },
        { key: "taxzap", label: "TaxZap fee can be claimed as an expense next year" },
        { key: "fines", label: "Avoid fines and stay compliant" },
        { key: "accountant", label: "Expert accountant review & filing done for you" },
    ];

    return (
        <div className={"submission-banner"}>

            <div className={"section-title"}>
                    Save money and time with TaxZap
            </div>
            <div className={"mt20 mb20 submission-banner__subtitle"}>
                    TaxZap is an easy-to-use platform that offers smarter tax solutions at a fraction of the cost of a traditional accountant.
            </div>
            <div>
                {isMobile ? <PriceTables/>
                    : <>
                        <Row gutter={16}>
                            <Col span={4} className="submission-banner__header-div submission-banner__table-header">
                                <Typography className="submission-banner__subheading" >Compare plans</Typography>
                                <Typography className="submission-banner__text">Choose the plan that works for your income type</Typography>
                            </Col>
                            {plans.map(plan => (
                                <Col span={5} key={plan.title} className="submission-banner__table-header">
                                    <div className="submission-banner__header-div">
                                        <div className="submission-banner__header">{plan.title}</div>
                                        <div className="submission-banner__header-price">{plan.price}</div>
                                    </div>
                                    <StartButtonPricing label="Get Started" authLabel="Continue" className={"shared__primary-button w80 mAuto"}/>
                                </Col>
                            ))}
                        </Row>
                        {featureLabels.map(({ key, label }) => (
                            <Row key={key} gutter={16} align="middle">
                                <Col span={4} className="submission-banner__table">{label}</Col>
                                {plans.map(plan => (
                                    <Col span={5} key={plan.title} className="submission-banner__table p20">
                                        {plan.features[key] || ""}
                                    </Col>
                                ))}
                            </Row>
                        ))}

                    </>}
            </div>
        </div>
    );
};
export default SubmissionBanner;
